import { FileTableItemType } from '@r1-compass-library/components/file-table/file-table.model';
import { RowOptionAction } from '@r1-compass-library/components';

export const defaultRowOptionActions: { [key in FileTableItemType]: RowOptionAction[] } = {
    asset: [
        { value: 'move', display: 'Move' },
        { value: 'delete', display: 'Delete' },
        { value: 'copy', display: 'Copy' },
    ],
    folder: [
        { value: 'edit', display: 'Edit' },
        { value: 'move', display: 'Move' },
    ],
};
